"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var map_installation_component_1 = __importDefault(require("./map-installation.component"));
var map_types_1 = require("./map.types");
var use_cluster_installations_1 = __importDefault(require("./use-cluster-installations"));
var installation_pin_container_component_1 = __importDefault(require("./installation-pin-container.component"));
function mostImportant(installation) {
    if (installation.numberOfAlerts && installation.numberOfAlerts > 0)
        return 'ALARM';
    if (installation.numberOfWarnings && installation.numberOfWarnings > 0)
        return 'WARNING';
    return undefined;
}
function recursiveClusteredAlerts(_a) {
    var installation = _a.installation, map = _a.map;
    if (installation.type === map_types_1.MapInstallationType.INSTALLATION) {
        map[installation.id] = mostImportant(installation);
        return map;
    }
    var updatedMap = __assign({}, map);
    var cluster = installation;
    cluster.installationsInCluster.forEach(function (installation) {
        updatedMap = __assign(__assign({}, map), recursiveClusteredAlerts({ installation: installation, map: map }));
    });
    return updatedMap;
}
function mapClusteredAlerts(props) {
    var alertsAndWarnings = recursiveClusteredAlerts(props);
    var numberOfAlerts = lodash_1.default.values(alertsAndWarnings).filter(function (value) { return value === 'ALARM'; }).length;
    var numberOfWarnings = lodash_1.default.values(alertsAndWarnings).filter(function (value) { return value === 'WARNING'; }).length;
    return { numberOfAlerts: numberOfAlerts, numberOfWarnings: numberOfWarnings };
}
exports.mapClusteredAlerts = mapClusteredAlerts;
var ClusteredMapInstallations = function (props) {
    var installations = props.installations, setBounds = props.setBounds, showDetails = props.showDetails;
    var clusteredInstallations = use_cluster_installations_1.default(installations);
    return (react_1.default.createElement(react_1.default.Fragment, null, clusteredInstallations.map(function (installation) {
        if (installation.type === map_types_1.MapInstallationType.CLUSTER) {
            var mapCluster_1 = installation;
            var _a = mapClusteredAlerts({
                installation: installation,
                map: {},
            }), numberOfAlerts = _a.numberOfAlerts, numberOfWarnings = _a.numberOfWarnings;
            var status_1 = numberOfAlerts > 0
                ? map_types_1.InstallationStatus.ERROR
                : numberOfWarnings > 0
                    ? map_types_1.InstallationStatus.WARNING
                    : map_types_1.InstallationStatus.ALL_GOOD;
            return (react_1.default.createElement(installation_pin_container_component_1.default, { key: installation.id, installationStatus: status_1, onClick: function () {
                    setBounds(mapCluster_1.installationsInCluster.map(function (installation) { return [
                        installation.location.latitude,
                        installation.location.longitude,
                    ]; }));
                }, location: mapCluster_1.location, type: map_types_1.MapInstallationType.CLUSTER, numberInCluster: mapCluster_1.installationsInCluster.length, numberOfAlerts: numberOfAlerts, numberOfWarnings: numberOfWarnings }));
        }
        var mapInstallation = installation;
        return (react_1.default.createElement(map_installation_component_1.default, { key: mapInstallation.id, installation: mapInstallation, showDetails: showDetails }));
    })));
};
exports.default = ClusteredMapInstallations;
